/*
 * Copy inbound campaign UTMs onto Cozy Storytime app links.
 *
 * Loaded only on the Storytime page templates. When the page URL has any of
 * utm_source, utm_medium, utm_campaign, utm_content, or utm_term, those
 * values are added to every anchor whose href starts with
 * https://app.cozystorytime.com. A param already on the link is left alone.
 * Other query params and the hash stay put. With no inbound UTMs the script
 * returns before it touches the DOM.
 *
 * cozy-latest-episode.js replaces the new-episode href after its fetch
 * (up to about 3s). A MutationObserver retags that write. A capture-phase
 * click and pointerdown do the same if a href changes on the way to the tap.
 * pod.link and every other host are ignored.
 */
(function () {
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var APP_ORIGIN = 'https://app.cozystorytime.com';

  function utmPairs(search) {
    var incoming = new URLSearchParams(search || '');
    var pairs = [];
    for (var i = 0; i < UTM_KEYS.length; i++) {
      var key = UTM_KEYS[i];
      if (!incoming.has(key)) continue;
      var value = incoming.get(key);
      if (value == null || String(value).trim() === '') continue;
      pairs.push([key, value]);
    }
    return pairs;
  }

  function isAppHref(href) {
    if (typeof href !== 'string' || href.indexOf(APP_ORIGIN) !== 0) return false;
    try {
      return new URL(href).hostname === 'app.cozystorytime.com';
    } catch (e) {
      return false;
    }
  }

  function appendUtms(href, search) {
    var pairs = utmPairs(search);
    if (!pairs.length || !isAppHref(href)) return href;
    var url;
    try {
      url = new URL(href);
    } catch (e) {
      return href;
    }
    var changed = false;
    for (var i = 0; i < pairs.length; i++) {
      if (url.searchParams.has(pairs[i][0])) continue;
      url.searchParams.set(pairs[i][0], pairs[i][1]);
      changed = true;
    }
    return changed ? url.toString() : href;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      UTM_KEYS: UTM_KEYS,
      appendUtms: appendUtms,
    };
  }

  if (typeof document === 'undefined' || typeof window === 'undefined') return;

  var search = window.location.search || '';
  if (!utmPairs(search).length) return;

  function tagAnchor(node) {
    if (!node || node.nodeType !== 1 || node.tagName !== 'A') return;
    var href = node.getAttribute('href');
    var next = appendUtms(href, search);
    if (next !== href) node.setAttribute('href', next);
  }

  function tagRoot(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.nodeType === 1) tagAnchor(root);
    var list = root.querySelectorAll('a[href^="https://app.cozystorytime.com"]');
    for (var i = 0; i < list.length; i++) tagAnchor(list[i]);
  }

  function anchorFrom(target) {
    var node = target;
    if (node && node.nodeType === 3) node = node.parentNode;
    while (node && node !== document) {
      if (node.tagName === 'A') return node;
      node = node.parentNode;
    }
    return null;
  }

  function onActivate(event) {
    var anchor = anchorFrom(event.target);
    if (anchor) tagAnchor(anchor);
  }

  function boot() {
    tagRoot(document);
    if (!window.MutationObserver || !document.documentElement) return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === 'attributes') {
          tagAnchor(mutation.target);
          continue;
        }
        var added = mutation.addedNodes;
        for (var j = 0; j < added.length; j++) tagRoot(added[j]);
      }
    });
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['href'],
    });
  }

  document.addEventListener('pointerdown', onActivate, true);
  document.addEventListener('click', onActivate, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
